// src/components/layout/Footer.tsx
import React from 'react';

interface FooterProps {
  onShowContact: () => void;
  onShowPrivacy: () => void;
  onShowTerms: () => void;
  onShowAbout: () => void;
}

export const Footer: React.FC<FooterProps> = ({
  onShowContact,
  onShowPrivacy,
  onShowTerms,
  onShowAbout
}) => {
  return (
    <footer className="bg-white border-t py-4">
      <div className="flex flex-col md:flex-row md:justify-between md:items-center items-center text-sm text-gray-500 px-8 space-y-2 md:space-y-0">
        <div className="flex space-x-6 order-1 md:order-2">
          <button 
            onClick={onShowAbout}
            className="hover:text-gray-700 transition-colors cursor-pointer"
          >
            About
          </button>
          <button 
            onClick={onShowContact}
            className="hover:text-gray-700 transition-colors cursor-pointer"
          >
            Contact
          </button>
          <button 
            onClick={onShowPrivacy}
            className="hover:text-gray-700 transition-colors cursor-pointer"
          >
            Privacy
          </button>
          <button 
            onClick={onShowTerms}
            className="hover:text-gray-700 transition-colors cursor-pointer"
          >
            Terms
          </button>
        </div>
        <p className="order-2 md:order-1">&copy; 2025 Dairy Translate</p>
      </div>
    </footer>
  );
};